import { getPlatform } from "../utils/CommonFunctions";

type NativeBridgeMessageTypes =
  | "WebPageCallbackOpenWallet"
  | "setBackButtonVisible"
  | "setBottomBarVisible"
  | "setTopBarVisible"
  | "openWebLink"
  | "showContactSheet"
  | "getAppVersion"
  | "getCurrentPosition"
  | "setValues"
  | "hideBackForUrls"
  | "getLocation"
  | "getLocationPermission";

// eslint-disable-next-line import/no-mutable-exports
let postMessage: (type: NativeBridgeMessageTypes, value?: any, stringify?: boolean) => any;

const isObject = (obj: unknown): boolean => obj !== null && typeof obj === "object";

const postMessageAndroid = (type, value, stringify) => {
  if (window.Android[type] != null) {
    if (isObject(value)) {
      if (stringify) {
        return window.Android[type](JSON.stringify(value));
      }

      return window.Android[type](...Object.values(value));
    }

    if (value === undefined || value === null) {
      return window.Android[type]();
    }

    return window.Android[type](value);
  }
};

const postMessageIos = (type, value) => {
  window.webkit?.messageHandlers?.ToApp?.postMessage({
    type: type,
    value: value,
  });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const postMessageWeb = (type, value) => {
  if (type === "openWebLink") {
    document.location = value.url;
  }
};

const initializeNativePostMessageService = () => {
  const platform = getPlatform();
  const postMessageMap = {
    iOS: postMessageIos,
    Android: postMessageAndroid,
    Web: postMessageWeb,
  };
  postMessage = platform.native ? postMessageMap[platform.os] : postMessageMap.Web;
};

export { postMessage, initializeNativePostMessageService };
